import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

const placeOrderApi = async (items, shippingAddress, isCartInvolved) => {
    try {

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/order`,
            {
                items,
                shippingAddress,
                isCartInvolved
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        toast.success("Order placed successfully");
        return res.data.data;

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const getOrderFunction = async (pageNumber, pageSize, search, field, dateRange) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);
        params.append('dateRange', dateRange);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/order?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        console.log(res)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getOrderByIdFunction = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/order/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const updateOrderById = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
            return
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.put(`/order/${id}/update`,
            {
                orderStatus: "Cancelled"
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
        toast.success("Successfully updated!");
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export { placeOrderApi, getOrderFunction, getOrderByIdFunction };
